(() => {
  'use strict';
  const toCents = value => {
    const text = String(value).trim();
    if (!text) return 0;
    if (!/^(?:\d+|\d{1,3}(?:,\d{3})+)(?:\.\d{1,2})?$/.test(text)) throw new Error('Enter a positive amount with up to two decimal places.');
    const [whole, fraction = ''] = text.replaceAll(',', '').split('.');
    const amount = Number(whole) * 100 + Number(fraction.padEnd(2, '0'));
    if (!Number.isSafeInteger(amount) || amount > 100000000000) throw new Error('Enter £1 billion or less in each field.');
    return amount;
  };
  const calculate = ({assets, debts, threshold}) => {
    if (String(assets).trim() === '') throw new Error('Enter your asset total, or 0 if you have none.');
    const total = toCents(assets), debt = toCents(debts), nisab = toCents(threshold);
    if (nisab <= 0) throw new Error('Enter a threshold greater than zero.');
    const net = total - debt, meetsThreshold = net >= nisab;
    return {assets:total, debts:debt, net, threshold:nisab, meetsThreshold, amount:meetsThreshold ? Math.ceil(net / 40) : 0};
  };
  const londonDate = date => new Intl.DateTimeFormat('en-CA',{timeZone:'Europe/London',year:'numeric',month:'2-digit',day:'2-digit'}).format(date);
  const rateIsCurrent = (checkedDate, date = new Date()) => checkedDate === londonDate(date);
  if (typeof module !== 'undefined' && module.exports) module.exports = {toCents, calculate, rateIsCurrent};
  if (typeof document === 'undefined') return;
  const money = cents => new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP'}).format(cents / 100);
  function start() {
    for (const root of document.querySelectorAll('[data-i23-calculator]')) {
      if (root.dataset.ready) continue;
      root.dataset.ready = 'true';
      const q = key => root.querySelector('[data-z-'+key+']'), form = root.querySelector('form');
      let calculated = false, editedThreshold = false;
      const fresh = () => rateIsCurrent(root.dataset.rateDate);
      function checkDate() {
        const stale = !fresh();
        q('confirm-wrap').hidden = !stale;
        q('rate-label').textContent = editedThreshold ? 'Your chosen threshold' : stale ? 'Gold threshold · checked 24 October 2026' : 'Gold threshold today';
        if (stale) q('method').open = true;
        return stale;
      }
      function clearResult(title='Your payment-day estimate') {
        calculated=false;q('result-title').textContent=title;q('result').textContent='—';
        ['total-assets','total-debts','net'].forEach(k=>q(k).textContent='—');
        q('explanation').textContent='At or above the threshold: 2.5% of your whole net wealth. Below it: £0.';q('next').hidden=true;
      }
      form.addEventListener('input',event=>{if(calculated)clearResult('Figures changed · calculate again');q('error').hidden=true;if(event.target===q('nisab')){editedThreshold=true;q('confirm').checked=false;checkDate();try{q('rate-display').textContent=money(toCents(q('nisab').value));}catch{q('rate-display').textContent='—';}}});
      form.addEventListener('change',()=>{if(calculated)clearResult('Figures changed · calculate again');});
      form.addEventListener('submit',event=>{
        event.preventDefault();q('error').hidden=true;
        try {
          if(checkDate()&&!q('confirm').checked) throw new Error('The reference rate is from 24 October 2026. Check today’s threshold below and confirm it before calculating.');
          const result=calculate({assets:q('assets').value,debts:q('debts').value,threshold:q('nisab').value});
          q('total-assets').textContent=money(result.assets);q('total-debts').textContent=money(result.debts);q('net').textContent=money(result.net);q('result').textContent=money(result.amount);
          q('result-title').textContent=result.meetsThreshold?'Your estimated Zakat / Tax':'No Zakat payable on this calculation';
          q('explanation').textContent=result.meetsThreshold?money(result.net)+' × 2.5% = '+money(result.amount)+'. This applies to your whole net wealth.':'Below the '+money(result.threshold)+' threshold: no Zakat payable on this calculation.';
          q('next').hidden=result.meetsThreshold;q('next').textContent='Under this approach, payment becomes due after one full lunar year of qualifying wealth, starting when you reach the threshold again.';calculated=true;
        } catch(error) {clearResult();q('error').textContent=error.message;q('error').hidden=false;}
      });
      form.addEventListener('reset',()=>queueMicrotask(()=>{editedThreshold=false;q('error').hidden=true;clearResult();q('rate-display').textContent='£7,563';q('method').open=false;checkDate();}));
      checkDate();
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
